import React, { useEffect, useState } from "react";
import { Wheel } from "react-custom-roulette";
import axios from "axios";
import CelebrationComponent from "../components/CelebrationComponent";
import Modal from "../components/Modal";
import arrow from "../assets/arrow.png";
import Clock from "../components/Clock";

const LiveResult = () => {
  const [explosation, setExplosation] = useState(false);
  const [openModal, setOpenModal] = useState(true);

  const blackWhiteData = [
    {
      option: "Black",
      style: { backgroundColor: "black", textColor: "white", fontSize: 32 },
    },
    {
      option: "White",
      style: { backgroundColor: "#CDCBBC", textColor: "black", fontSize: 32 },
    },
    {
      option: "Black",
      style: { backgroundColor: "black", textColor: "white", fontSize: 32 },
    },
    {
      option: "White",
      style: { backgroundColor: "#CDCBBC", textColor: "black", fontSize: 32 },
    },
    {
      option: "Black",
      style: { backgroundColor: "black", textColor: "white", fontSize: 32 },
    },
    {
      option: "White",
      style: { backgroundColor: "#CDCBBC", textColor: "black", fontSize: 32 },
    },
  ];

  const numberData = Array.from({ length: 10 }, (_, i) => ({
    option: i.toString(),
    style: {
      backgroundColor: "#CDCBBC",
      textColor: "black",
      fontSize: 40,
    },
  }));

  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumberBlackWhite, setPrizeNumberBlackWhite] = useState(0);
  const [prizeNumberSingle, setPrizeNumberSingle] = useState(0);
  const [prizeNumberDoubleLast, setPrizeNumberDoubleLast] = useState(0);
  const [prizeNumberDoublePrev, setPrizeNumberDoublePrev] = useState(0);
  const [apiData, setApiData] = useState(null);
  const [nowSpin, setNowSpin] = useState(false);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://customer-api.threecircle5.com/results/fetch-live-result"
      );
      const result = response.data.response;
      console.log(response?.data?.response);

      setApiData(result);

      const indexBlackWhite = blackWhiteData.findIndex(
        (item) => item.option === result.colorResult
      );
      const indexSingle = numberData.findIndex(
        (item) => item.option === result.singleResult
      );

      const doubleResult = result.doubleResult;
      const firstDigit = parseInt(doubleResult.charAt(0), 10);
      const secondDigit = parseInt(doubleResult.charAt(1), 10);

      setPrizeNumberBlackWhite(indexBlackWhite !== -1 ? indexBlackWhite : 0);
      setPrizeNumberSingle(indexSingle !== -1 ? indexSingle : 0);
      setPrizeNumberDoubleLast(firstDigit);
      setPrizeNumberDoublePrev(secondDigit);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();

    const checkTimeAndFetchData = () => {
      const currentTime = new Date();
      const minutes = currentTime.getMinutes();
      console.log(minutes, currentTime);

      if (minutes === 0 || minutes === 30) {
        setExplosation(false);
        setOpenModal(false);
        fetchData();
        setMustSpin(true);
      }
    };

    // Run the check initially and then set an interval to check every minute
    checkTimeAndFetchData(); // Run once on mount
    const intervalId = setInterval(checkTimeAndFetchData, 60000); // Check every 1 minute

    return () => {
      clearInterval(intervalId); // Clear interval on component unmount
    };
  }, []);

  const stopSpin = () => {
    setMustSpin(false);
    setExplosation(true);
    setOpenModal(true);
  };

  const spinReview = () => {
    setExplosation(false);
    setOpenModal(false);
    fetchData();
    setMustSpin(true);
  };

  return (
    <div className="bg-no-repeat bg-cover min-h-screen overflow-hidden p-[10px]">
      <Modal
        openModal={openModal}
        data={apiData}
        onClick={() => spinReview()}
      />
      <div className="flex justify-center gap-4 max-w-full sm:max-w-[360px] m-auto text-[12px] font-[700] py-3 rounded-[10px] bg-[#FDF5EA] mb-[10px]">
        <h4>{apiData?.gameDateSlot}</h4> |<h4>{apiData?.gameTimeSlot}</h4> |{" "}
        <Clock />
      </div>
      <div className="flex relative justify-start max-w-full sm:max-w-[360px] gap-[10px] m-auto">
        <div className="flex flex-col gap-[5px] w-fit items-center flex-wrap rounded-[10px] bg-[#FDF5EA]">
          <div className="p-[20px]">
            <div className="w-[250px] h-[250px] flex justify-center items-center relative">
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute top-0 left-0"></span>
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute bottom-0 left-0"></span>
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute top-0 right-0"></span>
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute bottom-0 right-0"></span>
              <div
                style={{
                  // backgroundColor: "white",
                  width: "250px",
                  rotate: "225deg",
                }}
              >
                <div
                  className="small-spinner"
                  style={{
                    width: "250px",
                    backgroundColor: "#CDCBBC",
                    boxShadow:
                      "rgba(0, 0, 0, 0.5) -9px -3px 14px, rgba(0, 0, 0, 0.0) 0px 7px 8px",
                    borderRadius: "50%",
                  }}
                >
                  <Wheel
                    mustStartSpinning={mustSpin}
                    prizeNumber={prizeNumberBlackWhite}
                    data={blackWhiteData}
                    onStopSpinning={() => stopSpin()}
                    innerRadius={3}
                    outerBorderWidth={0}
                    innerBorderColor="#eeeeee"
                    innerBorderWidth="10"
                    pointerProps={{
                      src: arrow,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="steel-rod"></div>

          <div className="p-[20px]">
            <div className="w-[250px] h-[250px] flex justify-center items-center relative">
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute top-0 left-0"></span>
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute bottom-0 left-0"></span>
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute top-0 right-0"></span>
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute bottom-0 right-0"></span>
              <div
                style={{
                  // backgroundColor: "white",
                  width: "250px",
                  rotate: "225deg",
                }}
              >
                <div
                  className="small-spinner"
                  style={{
                    width: "250px",
                    backgroundColor: "#CDCBBC",
                    boxShadow:
                      "rgba(0, 0, 0, 0.5) -9px -3px 14px, rgba(0, 0, 0, 0.0) 0px 7px 8px",
                    borderRadius: "50%",
                  }}
                >
                  <Wheel
                    mustStartSpinning={mustSpin}
                    prizeNumber={prizeNumberSingle}
                    data={numberData}
                    onStopSpinning={() => stopSpin()}
                    textDistance={70}
                    outerBorderWidth={0}
                    radiusLineColor="black"
                    innerRadius={3}
                    innerBorderColor="#eeeeee"
                    innerBorderWidth="10"
                    pointerProps={{
                      src: arrow,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="steel-rod"></div>

          <div className="p-[20px]">
            <div className="w-[250px] h-[250px] flex justify-center items-center relative">
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute top-0 left-0"></span>
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute bottom-0 left-0"></span>
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute top-0 right-0"></span>
              <span className="w-[10px] h-[10px] bg-[#522D2D] rounded-full absolute bottom-0 right-0"></span>
              <div
                style={{
                  position: "relative",
                  width: "250px",
                  height: "250px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  rotate: "225deg",
                  // backgroundColor: "white",
                }}
              >
                <div
                  className="small-spinner"
                  style={{
                    width: "250px",
                    backgroundColor: "#CDCBBC",
                    boxShadow:
                      "rgba(0, 0, 0, 0.5) -9px -3px 14px, rgba(0, 0, 0, 0.0) 0px 7px 8px",
                    borderRadius: "50%",
                    position: "absolute",
                  }}
                >
                  <Wheel
                    mustStartSpinning={mustSpin}
                    prizeNumber={prizeNumberDoubleLast}
                    data={numberData}
                    onStopSpinning={() => stopSpin()}
                    textDistance={85}
                    outerBorderWidth={0}
                    radiusLineColor="black"
                    innerRadius={3}
                    innerBorderColor="#eeeeee"
                    innerBorderWidth="10"
                    pointerProps={{
                      src: arrow,
                    }}
                  />
                </div>
                <div
                  className="inner-wheel"
                  style={{
                    width: "150px",
                    position: "absolute",
                    backgroundColor: "#CDCBBC",
                  }}
                >
                  <Wheel
                    mustStartSpinning={mustSpin}
                    prizeNumber={prizeNumberDoublePrev}
                    data={numberData}
                    onStopSpinning={() => stopSpin()}
                    textDistance={70}
                    outerBorderColor="#000000"
                    radiusLineColor="black"
                    innerRadius={3}
                    innerBorderColor="#eeeeee"
                    innerBorderWidth="10"
                    pointerProps={{
                      src: arrow,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#FDF5EA] rounded-[10px] w-[calc(100%_-_290px)] flex flex-col  items-center text-3xl font-bold justify-evenly">
          <span>3</span>
          <span>C</span>
          <span>I</span>
          <span>R</span>
          <span>C</span>
          <span>L</span>
          <span>E</span>
        </div>
        <CelebrationComponent
          explosation={explosation}
          setExplosation={setExplosation}
        />
      </div>
    </div>
  );
};

export default LiveResult;
